module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.loadedScenario))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Название сценария")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.name),
      expression: "scenario.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Введите название сценария"
    },
    domProps: {
      "value": (_vm.scenario.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Вопрос 1")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionFirstGenerationState),
      expression: "scenario.parameters.questionFirstGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionFirstGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionFirstGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationStateStatic('questionFirstGenerationState', 'questionFirstAudio', 'questionFirstGeneratedAudio', 'questionFirstLoadedAudio', 'onQuestionFirst')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionFirstGenerationState),
      expression: "scenario.parameters.questionFirstGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionFirstGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionFirstGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationStateStatic('questionFirstGenerationState', 'questionFirstAudio', 'questionFirstGeneratedAudio', 'questionFirstLoadedAudio', 'onQuestionFirst')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionFirstGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionFirstText),
      expression: "scenario.parameters.questionFirstText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionFirstText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionFirstText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudioStatic('questionFirstId', 'questionFirstAudio', 'currentSpeakerFirst', 'questionFirstGeneratedAudio', 'questionFirstText', 'questionFirstLoading', 'First question', 'currentEmotionFirst', 'currentSpeedFirst')
      }
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.tmp.questionFirstLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                Сгенерировать аудио\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerFirst),
      expression: "tmp.currentSpeakerFirst"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerFirst", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                    " + _vm._s(speaker.value) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionFirst),
      expression: "tmp.currentEmotionFirst"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionFirst", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                    " + _vm._s(emotion.value) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedFirst,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedFirst = $event
      }
    }
  }), _vm._v("\n                Скорость: " + _vm._s(_vm.tmp.currentSpeedFirst) + "\n              ")], 1), _vm._v(" "), (_vm.tmp.questionFirstGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionFirst'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionFirstAudio
    }
  }), _vm._v("\n                Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionFirstGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionFirstAudio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionFirstId != '') ? _c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudioStatic('questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'questionFirstGeneratedAudio')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionFirstGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionFirstLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    ref: "questionFirstLoadedAudio",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionFirstLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudioStatic('questionFirstLoadedAudio', 'questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'First question', 'onQuestionFirst')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'First question', true)
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionFirstLoadedAudio) ? _c('audio', {
    ref: 'onQuestionFirst'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionFirstAudio
    }
  }), _vm._v("\n                Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionFirstLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionFirstAudio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionFirstId != '') ? _c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudioStatic('questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'questionFirstGeneratedAudio')
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e()])]), _vm._v(" "), _c('span', {
    staticClass: "second-layer positive-scenario add-button-wrapper"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Опрос (При ответе Да на Вопрос 1)")]), _vm._v(" "), _vm._l((_vm.scenario.parameters.dynamicQuestions), function(parameter, index) {
    return _c('div', {
      key: parameter.key
    }, [(_vm.scenario.parameters.dynamicQuestions.length != index + 1) ? _c('label', {
      staticClass: "label"
    }, [_vm._v("Вопрос опроса " + _vm._s(index + 1))]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.dynamicQuestions.length == index + 1) ? _c('label', {
      staticClass: "label"
    }, [_vm._v("Заключительное сообщение")]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.scenario.parameters.dynamicQuestions[index].generationState),
        expression: "scenario.parameters.dynamicQuestions[index].generationState"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": false,
        "checked": _vm._q(_vm.scenario.parameters.dynamicQuestions[index].generationState, false)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.scenario.parameters.dynamicQuestions[index], "generationState", false)
        }, function($event) {
          return _vm.onChangeGenerationState(parameter.generationState, index, parameter.key)
        }]
      }
    }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.scenario.parameters.dynamicQuestions[index].generationState),
        expression: "scenario.parameters.dynamicQuestions[index].generationState"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": true,
        "checked": _vm._q(_vm.scenario.parameters.dynamicQuestions[index].generationState, true)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.scenario.parameters.dynamicQuestions[index], "generationState", true)
        }, function($event) {
          return _vm.onChangeGenerationState(parameter.generationState, index, parameter.key)
        }]
      }
    }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (parameter.generationState) ? _c('div', [_c('p', {
      staticClass: "control"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.text),
        expression: "parameter.text"
      }],
      staticClass: "textarea",
      domProps: {
        "value": (parameter.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(parameter, "text", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "control is-grouped"
    }, [_c('button', {
      staticClass: "button is-primary",
      on: {
        "click": function($event) {
          return _vm.genAudio(index)
        }
      }
    }, [_vm._m(3, true), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicLoading) ? _c('div', {
      staticClass: "loader spinner"
    }) : _vm._e(), _vm._v("\n                Сгенерировать аудио\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "select is-primary"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.tmp.dynamicTmp[index].dynamicSpeaker),
        expression: "tmp.dynamicTmp[index].dynamicSpeaker"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.tmp.dynamicTmp[index], "dynamicSpeaker", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.speakerList), function(speaker) {
      return _c('option', [_vm._v("\n                    " + _vm._s(speaker.value) + "\n                  ")])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "select is-primary"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.tmp.dynamicTmp[index].dynamicEmotion),
        expression: "tmp.dynamicTmp[index].dynamicEmotion"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.tmp.dynamicTmp[index], "dynamicEmotion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.emotionList), function(emotion) {
      return _c('option', [_vm._v("\n                    " + _vm._s(emotion.value) + "\n                  ")])
    }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
      attrs: {
        "size": "small",
        "value": _vm.tmp.dynamicTmp[index].dynamicSpeed,
        "min": 0.1,
        "step": 0.1,
        "max": 3
      },
      on: {
        "change": function($event) {
          _vm.tmp.dynamicTmp[index].dynamicSpeed = $event
        }
      }
    }), _vm._v("\n                Скорость: " + _vm._s(_vm.tmp.dynamicTmp[index].dynamicSpeed) + "\n              ")], 1), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicGeneratedAudio) ? _c('audio', {
      ref: ("audio-" + (parameter.key)),
      refInFor: true
    }, [_c('source', {
      attrs: {
        "src": parameter.audio
      }
    }), _vm._v("\n                Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicGeneratedAudio) ? _c('audio-player', {
      attrs: {
        "file": parameter.audio
      }
    }) : _vm._e(), _vm._v(" "), (index !== 0) ? _c('button', {
      staticClass: "button is-link delete-button",
      on: {
        "click": function($event) {
          return _vm.deleteParameter(index)
        }
      }
    }, [_vm._m(4, true), _vm._v(" "), _c('span', [_vm._v("Удалить")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!parameter.generationState) ? _c('div', [_c('p', {
      staticClass: "control"
    }), _c('div', {
      staticClass: "control"
    }, [_c('input', {
      staticClass: "button is-info",
      attrs: {
        "type": "button",
        "value": "Загрузить из файла"
      },
      on: {
        "click": function($event) {
          return _vm.clickLoadAudio(parameter.key)
        }
      }
    }), _vm._v(" "), _c('input', {
      ref: ("load-audio-" + (parameter.key)),
      refInFor: true,
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "name": "load-audio",
        "type": "file",
        "accept": ".wav,.mp3"
      },
      on: {
        "input": function($event) {
          return _vm.loadAudio(index, parameter.key)
        }
      }
    }), _vm._v(" "), _c('input', {
      staticClass: "button is-info",
      attrs: {
        "type": "button",
        "value": "Записать с микрофона"
      },
      on: {
        "click": function($event) {
          return _vm.openModal(index, parameter.key, '', '', false)
        }
      }
    }), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicLoadedAudio) ? _c('audio', {
      ref: ("audio-" + (parameter.key)),
      refInFor: true
    }, [_c('source', {
      attrs: {
        "src": parameter.audio
      }
    }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicLoadedAudio) ? _c('audio-player', {
      attrs: {
        "file": parameter.audio
      }
    }) : _vm._e(), _vm._v(" "), (index !== 0) ? _c('button', {
      staticClass: "button is-link delete-button",
      on: {
        "click": function($event) {
          return _vm.deleteParameter(index)
        }
      }
    }, [_vm._m(5, true), _vm._v(" "), _c('span', [_vm._v("Удалить")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "button-center"
  }, [_c('button', {
    staticClass: "button is-primary is-outlined add-new",
    on: {
      "click": _vm.addNewParameter
    }
  }, [_vm._v("+")])])], 2), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "second-layer negative-scenario"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("При ответе Нет на Вопрос 1")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Вопрос 2 / Сообщение")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondGenerationState),
      expression: "scenario.parameters.questionSecondGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationStateStatic('questionSecondGenerationState', 'questionSecondAudio', 'questionSecondGeneratedAudio', 'questionSecondLoadedAudio', 'onQuestionSecond')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondGenerationState),
      expression: "scenario.parameters.questionSecondGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationStateStatic('questionSecondGenerationState', 'questionSecondAudio', 'questionSecondGeneratedAudio', 'questionSecondLoadedAudio', 'onQuestionSecond')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondText),
      expression: "scenario.parameters.questionSecondText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudioStatic('questionSecondId', 'questionSecondAudio', 'currentSpeakerSecond', 'questionSecondGeneratedAudio', 'questionSecondText', 'questionSecondLoading', 'Second question', 'currentEmotionSecond', 'currentSpeedSecond')
      }
    }
  }, [_vm._m(6), _vm._v(" "), (_vm.tmp.questionSecondLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecond),
      expression: "tmp.currentSpeakerSecond"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecond", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                      " + _vm._s(speaker.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecond),
      expression: "tmp.currentEmotionSecond"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecond", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                    " + _vm._s(emotion.value) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecond,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecond = $event
      }
    }
  }), _vm._v("\n                Скорость: " + _vm._s(_vm.tmp.currentSpeedSecond) + "\n              ")], 1), _vm._v(" "), (_vm.tmp.questionSecondGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecond'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondAudio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondId != '') ? _c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudioStatic('questionSecondId', 'questionSecondAudio', 'questionSecondLoadedAudio', 'questionSecondGeneratedAudio')
      }
    }
  }, [_vm._m(7), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudioStatic('questionSecondLoadedAudio', 'questionSecondId', 'questionSecondAudio', 'questionSecondLoadedAudio', 'Second question', 'onQuestionSecond')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondId', 'questionSecondAudio', 'questionSecondLoadedAudio', 'Second question', true)
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecond'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondAudio
    }
  }), _vm._v("\n                    Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondAudio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondId != '') ? _c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudioStatic('questionSecondId', 'questionSecondAudio', 'questionSecondLoadedAudio', 'questionSecondGeneratedAudio')
      }
    }
  }, [_vm._m(8), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "block is-flex"
  }, [_c('collapse', [_c('collapse-item', {
    staticClass: "second-layer positive-scenario",
    attrs: {
      "title": "Сообщение при ответе Да на Вопрос 2",
      "selected": _vm.scenario.parameters.questionSecondYesId != ''
    }
  }, [_c('div', [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesGenerationState),
      expression: "scenario.parameters.questionSecondYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondYesGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondYesGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationStateStatic('questionSecondYesGenerationState', 'questionSecondYesAudio', 'questionSecondYesGeneratedAudio', 'questionSecondYesLoadedAudio', 'onQuestionSecondYes')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesGenerationState),
      expression: "scenario.parameters.questionSecondYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondYesGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondYesGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationStateStatic('questionSecondYesGenerationState', 'questionSecondYesAudio', 'questionSecondYesGeneratedAudio', 'questionSecondYesLoadedAudio', 'onQuestionSecondYes')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesText),
      expression: "scenario.parameters.questionSecondYesText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondYesText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondYesText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudioStatic('questionSecondYesId', 'questionSecondYesAudio', 'currentSpeakerSecondYes', 'questionSecondYesGeneratedAudio', 'questionSecondYesText', 'questionSecondYesLoading', 'Second yes question', 'currentEmotionSecondYes', 'currentSpeedSecondYes')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })]), _vm._v(" "), (_vm.tmp.questionSecondYesLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecondYes),
      expression: "tmp.currentSpeakerSecondYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecondYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                      " + _vm._s(speaker.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecondYes),
      expression: "tmp.currentEmotionSecondYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecondYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                      " + _vm._s(emotion.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecondYes,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecondYes = $event
      }
    }
  }), _vm._v("\n                  Скорость: " + _vm._s(_vm.tmp.currentSpeedSecondYes) + "\n                ")], 1), _vm._v(" "), (_vm.tmp.questionSecondYesGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecondYes'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondYesAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondYesGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondYesAudio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesId != '') ? _c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudioStatic('questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'questionSecondYesGeneratedAudio')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondYesLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondYesLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudioStatic('questionSecondYesLoadedAudio', 'questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'Second yes question', 'onQuestionSecondYes')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'Second yes question', true)
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondYesLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecondYes'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondYesAudio
    }
  }), _vm._v("\n               Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondYesLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondYesAudio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesId != '') ? _c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudioStatic('questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'questionSecondYesGeneratedAudio')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e()])]), _vm._v(" "), _c('collapse-item', {
    staticClass: "second-layer negative-scenario",
    attrs: {
      "title": "Сообщение при ответе Нет на Вопрос 2",
      "selected": _vm.scenario.parameters.questionSecondNoId != ''
    }
  }, [_c('div', [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoGenerationState),
      expression: "scenario.parameters.questionSecondNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondNoGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondNoGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationStateStatic('questionSecondNoGenerationState', 'questionSecondNoAudio', 'questionSecondNoGeneratedAudio', 'questionSecondNoLoadedAudio', 'onQuestionSecondNo')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoGenerationState),
      expression: "scenario.parameters.questionSecondNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondNoGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondNoGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationStateStatic('questionSecondNoGenerationState', 'questionSecondNoAudio', 'questionSecondNoGeneratedAudio', 'questionSecondNoLoadedAudio', 'onQuestionSecondNo')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoText),
      expression: "scenario.parameters.questionSecondNoText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondNoText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondNoText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudioStatic('questionSecondNoId', 'questionSecondNoAudio', 'currentSpeakerSecondNo', 'questionSecondNoGeneratedAudio', 'questionSecondNoText', 'questionSecondNoLoading', 'Second no question', 'currentEmotionSecondNo', 'currentSpeedSecondNo')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })]), _vm._v(" "), (_vm.tmp.questionSecondNoLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecondNo),
      expression: "tmp.currentSpeakerSecondNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecondNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                      " + _vm._s(speaker.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecondNo),
      expression: "tmp.currentEmotionSecondNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecondNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                      " + _vm._s(emotion.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecondNo,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecondNo = $event
      }
    }
  }), _vm._v("\n                  Скорость: " + _vm._s(_vm.tmp.currentSpeedSecondNo) + "\n                ")], 1), _vm._v(" "), (_vm.tmp.questionSecondNoGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecondNo'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondNoAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondNoGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondNoAudio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoId != '') ? _c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudioStatic('questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'questionSecondNoGeneratedAudio')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondNoLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondNoLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudioStatic('questionSecondNoLoadedAudio', 'questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'Second no question', 'onQuestionSecondNo')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'Second no question', true)
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondNoLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecondNo'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondNoAudio
    }
  }), _vm._v("\n               Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondNoLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondNoAudio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoId != '') ? _c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudioStatic('questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'questionSecondNoGeneratedAudio')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e()])])], 1)], 1)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._m(9), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(10), _vm._v(" "), _c('span', [_vm._v("Закрыть")])]), _vm._v(" "), _vm._m(11), _vm._v(" "), (_vm.scenario.isReady) ? _c('button', {
    staticClass: "button is-success is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(12), _vm._v(" "), _c('span', [_vm._v("Подготовлен")])]) : _c('button', {
    staticClass: "button is-danger is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(13), _vm._v(" "), _c('span', [_vm._v("Не подготовлен")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal,
      "title": _vm.title
    },
    on: {
      "confirm": _vm.confirmAction,
      "close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-primary"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  })]), _vm._v(" "), _c('span', [_vm._v("Рассчитать стоимость")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fd87125"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/depricated/ScenarioQuestionInterview.vue
// module id = 526
// module chunks = 42